import React, { useState,useEffect, useRef } from "react";
import axios from "axios";
import {databaseUrl, databaseNoport} from '../../server/server.js'
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../server/axios.js";
import TextEditor from "../component/texteditor.js";

//ui material
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TextField } from "@mui/material";


let access = localStorage.getItem("accesstoken");

const Orderboards = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 추가된 부분
  const checkVIsitDay = location.state?.visitday; // 추가된 부분

  const [memo, setMemo] = useState({
    api:'/orderboard/memo',
    sendbutton:'메모변경 전송',
    contents:'loading...'
  })
  const [memoUpdate,setMemoUpdate] = useState("");

  const [memoEditorState, setMemoEditorState] = useState(0);
  const [memoEditor, setMemoEditor] = useState('메모편집기 열기');
  const showeditor = () => {
    if(memoEditorState === 0){
      setMemoUpdate(memo.contents);
      setMemoEditor('메모편집기 닫기');
      return setMemoEditorState(1);
    }
    setMemoEditor('메모편집기 열기');
    return setMemoEditorState(0);
  }



  //dragging
  const [draggingList, setDraggingList ] = useState([])
  const dragItem = useRef(null); // Specify the type for dragItem
  const dragOverItem = useRef(null); // Specify the type for dragOverItem
  const dragStart = (e,position) => {
    dragItem.current = position;
  };
  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };
  const drop = async (_totalArrList) => {
    //console.log('drop : ',_totalArrList);
    let list = _totalArrList.map((obejct)=> obejct.id);
    const copyListItems = [...list];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    const OrdersortingChange = await axiosInstance.get(`/orderboard/sortchange?list=${copyListItems}`);
  };
  //today time check
  const checkWeek = ['일','월','화','수','목','금','토'];
  const [nowtime, setNowtime] = useState('');
  //order day setting
  const orderdayCheck = new Date();
  const orderdayCheckYear = orderdayCheck.getFullYear();
  const orderdayCheckMonth = orderdayCheck.getMonth() + 1 >= 10 ? orderdayCheck.getMonth()+1 : '0'+(orderdayCheck.getMonth()+1);
  const orderdayCheckDate = orderdayCheck.getDate() < 10 ? '0'+(orderdayCheck.getDate()) : orderdayCheck.getDate();
  const [orderDay, setOrderDay] = useState(checkVIsitDay === undefined ? `${orderdayCheckYear}-${orderdayCheckMonth}-${orderdayCheckDate}` : checkVIsitDay );
  //const [orderDay, setOrderDay] = useState(``);
  const clickOrderday = (event) => {
    setOrderDay(event.target.value);
  }
  const beforeOrderDay = () => {
    const checkday = new Date(orderDay);
    checkday.setDate(checkday.getDate()-1);
    const orderdayCheckYear = checkday.getFullYear();
    const orderdayCheckMonth = checkday.getMonth() + 1 >= 10 ? checkday.getMonth()+1 : '0'+(checkday.getMonth()+1);
    const orderdayCheckDate = checkday.getDate() < 10 ? '0'+(checkday.getDate()) :checkday.getDate();    
    setOrderDay(`${orderdayCheckYear}-${orderdayCheckMonth}-${orderdayCheckDate}`);
  }
  const afterOrderDay = () => {
    const checkday = new Date(orderDay);
    checkday.setDate(checkday.getDate()+1);
    const orderdayCheckYear = checkday.getFullYear();
    const orderdayCheckMonth = checkday.getMonth() + 1 >= 10 ? checkday.getMonth()+1 : '0'+(checkday.getMonth()+1);
    const orderdayCheckDate = checkday.getDate() < 10 ? '0'+(checkday.getDate()) :checkday.getDate();    
    setOrderDay(`${orderdayCheckYear}-${orderdayCheckMonth}-${orderdayCheckDate}`);
  }
  const [getdataresult , setGetdataresult] = useState([]);
  const [getVisitresult , setGetVisitresult] = useState([]);
  const [getVisitCompanyResult , setVisitCompanyResult] = useState([]);
  const [notdepositList, setNotDepositList] = useState([]);
  const [receiveList, setReceiveList] = useState([]);
  const [asapList , setAsapList ] = useState([]);
  const [afterbuyList , setAfterbuyList ] = useState([]);
  const [finishedOrder , setFinishedOrder] = useState([]);
  const [stopCheck, setStopCheck] = useState([]);

  const [stockList, setStockList] = useState([]);

  const [showTable, setShowTable] = useState(false);

  const [count, setCount] = useState('');
  const Counter = () => {
     useEffect(() => {
      const intervalId = setInterval(() => {
        setCount( (prevCount) => {
          const visitman = [];
          const orderdata = [];
          const notdepositdata = [];
          const finishedOrder = [];
          let visitOtherDay = [];
          const asapArr = [];
          const afterbuy = [];
          const receiveList = [];
          const stopList = [];
          const settings = async () => {
            const order_server_Data = await axiosInstance.get(`/orderboard?checkdate=${orderDay}`);
            const indexVisitman = [];
            for(let i = 0; i < order_server_Data.data[0].length; i++){
              visitman.push({
                visitman : order_server_Data.data[0][i].visitman,
                car : order_server_Data.data[0][i].car,
                delivery : []});
              indexVisitman.push(order_server_Data.data[0][i].visitman);
            }
            visitman.push({visitman : '택배',delivery : []});
            indexVisitman.push('택배');
            visitman.push({visitman : '수향택배',delivery : []});
            indexVisitman.push('수향택배');
            visitman.push({visitman : '착불택배',delivery : []});
            indexVisitman.push('착불택배');
            visitman.push({visitman : '직송',delivery : []});
            indexVisitman.push('직송');
            visitman.push({visitman : '화물',delivery : []});
            indexVisitman.push('화물');
            visitman.push({visitman : '직접수령',delivery : []});
            indexVisitman.push('직접수령');
            visitman.push({visitman : '미정',delivery : []});
            indexVisitman.push('미정');

            //orderlist & check ASAP
            for(let i = 0; i < order_server_Data.data[1].length; i++){
              const isfinished = order_server_Data.data[1][i].order_company.indexOf('완료:');
              if(isfinished !== -1){
                finishedOrder.push(order_server_Data.data[1][i]);
                continue;
              }
              orderdata.push(order_server_Data.data[1][i]);  
              for(let j = 0; j < order_server_Data.data[1][i].order_info.length; j++){

                const checkASAPTEXT =  order_server_Data.data[1][i].order_info[j].note;
                const ASAPLIST = checkASAPTEXT.toLowerCase().indexOf('asap');
                if(ASAPLIST !== -1){asapArr.push(order_server_Data.data[1][i].order_info[j])}
                const AfterBuyList = checkASAPTEXT.toLowerCase().indexOf('수입후');
                if(AfterBuyList !== -1){afterbuy.push(order_server_Data.data[1][i].order_info[j])}

                const checkStop = Number(order_server_Data.data[1][i].order_info[j].stop);
                const checkInput = order_server_Data.data[1][i].order_info[j].note.indexOf('입고후');
                if(checkStop !== 0){
                  stopList.push(order_server_Data.data[1][i].order_info[j]);
                  continue;
                }
                if(checkInput !== -1){
                  stopList.push(order_server_Data.data[1][i].order_info[j])
                  continue;
                }
              }
            }

            for(let i = 0; i < order_server_Data.data[4].length; i++){
              notdepositdata.push(order_server_Data.data[4][i]);  
            }

            //visitman & 주간 일정 정리
            let visitCompanyDay = '';
            const visitCompanyDayIndex = []; 
            let materialList = [];
            for(let i = 0; i < order_server_Data.data[2].length; i++){
              const checkStop = Number(order_server_Data.data[2][i].stop);
              const checkWords = order_server_Data.data[2][i].note  ?? 'null';
              const checkInput = checkWords.indexOf('입고후');
              if(checkStop !== 0){continue;}
              if(checkInput !== -1){continue;}
              const checkday = order_server_Data.data[2][i].due_date.substring(0,10);
              const checkSellerCompany = order_server_Data.data[2][i].note;
              const checkOtherPlace = containsKeyword(checkSellerCompany,['배송처:','납품처:','배송:','납품:']);
              const checkDirect = containsKeytoDirect(checkSellerCompany,order_server_Data.data[2][i].visitor);
              const Result = checkResult(order_server_Data.data[2][i].result);
              const visitor = order_server_Data.data[2][i].visitor === '미정' ? ' .' : '';
              const newCompanyName = Result+checkDirect+order_server_Data.data[2][i].company+visitor+checkOtherPlace;
              //'코스모코스 (COSMOCO Co.Ltd)' -> 코스모코스
              //make visitman today arr
              if(checkday === orderDay){
                const indexVisit = indexVisitman.indexOf(order_server_Data.data[2][i].visitor) !== -1 ? indexVisitman.indexOf(order_server_Data.data[2][i].visitor) : indexVisitman.indexOf('미정');
                const arrLength = visitman[indexVisit].delivery.length;
                const pushOrder = () => {
                  visitman[indexVisit].delivery.push({
                    id:order_server_Data.data[2][i].id,
                    //company:order_server_Data.data[2][i].company,
                    company:newCompanyName,
                    weight: Number(order_server_Data.data[2][i].weight),
                    sort:Number(order_server_Data.data[2][i].sorting) ?? 0
                  })
                }
                if(arrLength === 0){
                  pushOrder();
                }else{
                  const frontCompanyName = visitman[indexVisit].delivery[arrLength-1].company;
                  //const backCompanyName = order_server_Data.data[2][i].company;
                  const backCompanyName = newCompanyName;
                  if(frontCompanyName === backCompanyName){
                    const frontWeight = visitman[indexVisit].delivery[arrLength-1].weight;
                    const backWeight = Number(order_server_Data.data[2][i].weight);
                    visitman[indexVisit].delivery[arrLength-1].weight = frontWeight+backWeight;
                  }else{
                    pushOrder();
                  }
                }
              }
              //make visitman oderDay arr
              const weight = Number(order_server_Data.data[2][i].weight);
              if(weight === 0){continue;}
              if(visitCompanyDay === checkday){
                const index = visitCompanyDayIndex.indexOf(checkday);
                const arrLength = visitOtherDay[index].delivery.length;
                const frontCompanyName = visitOtherDay[index].delivery[arrLength-1].company;
                //const backCompanyName = order_server_Data.data[2][i].company;
                const backCompanyName = newCompanyName;
                if(frontCompanyName === backCompanyName){
                  const frontWeight = visitOtherDay[index].delivery[arrLength-1].weight;
                  const backWeight = Number(order_server_Data.data[2][i].weight);
                  const frontIdList = visitOtherDay[index].delivery[arrLength-1].id_List;
                  const backIdList = order_server_Data.data[2][i].boards_id;
                  visitOtherDay[index].delivery[arrLength-1].weight = frontWeight+backWeight;
                  visitOtherDay[index].delivery[arrLength-1].id_List = frontIdList+backIdList+',';
                  visitOtherDay[index].delivery[arrLength-1].materialList.push({
                    id:order_server_Data.data[2][i].id,
                    material:order_server_Data.data[2][i].material,
                    weight:order_server_Data.data[2][i].weight,
                    note:order_server_Data.data[2][i].note
                  })
                }else{
                  visitOtherDay[index].delivery.push({
                    visitor:order_server_Data.data[2][i].visitor,
                    //company:order_server_Data.data[2][i].company,
                    company:newCompanyName,
                    weight: Number(order_server_Data.data[2][i].weight),
                    id_List:order_server_Data.data[2][i].boards_id+',',
                    materialList:[{
                      id:order_server_Data.data[2][i].id,
                      material:order_server_Data.data[2][i].material,
                      weight:order_server_Data.data[2][i].weight,
                      note:order_server_Data.data[2][i].note
                    }]
                  })
                }
              }else{
                visitCompanyDay = checkday;
                visitCompanyDayIndex.push(checkday);
                visitOtherDay.push({
                  date:checkday,
                  delivery:[{
                    visitor:order_server_Data.data[2][i].visitor,
                    //company:order_server_Data.data[2][i].company,
                    company:newCompanyName,
                    weight: Number(order_server_Data.data[2][i].weight),
                    id_List:order_server_Data.data[2][i].boards_id+',',
                    materialList:[{
                      id:order_server_Data.data[2][i].id,
                      material:order_server_Data.data[2][i].material,
                      weight:order_server_Data.data[2][i].weight
                    }]
                  }]
                })
              }
            }
            for(let i = 0; i < visitman.length; i++){
              const SortingArr = visitman[i].delivery.sort((a, b) => a.sort - b.sort || a.company.localeCompare(b.company));
              visitman[i].delivery = SortingArr;
            }
            for(let i = 0; i < visitOtherDay.length; i++){
              visitOtherDay[i].delivery = visitOtherDay[i].delivery.sort((a, b) => {
               const aHasWord = a.visitor === "직송" ? 5 : a.visitor.indexOf("택배") !== -1 ? 4 : a.visitor.length >= "3" ? 3 : a.company.indexOf('(완료)') !== -1 ? 2 : a.visitor === "미정" ? 1 : -1;
               const bHasWord = b.visitor === "직송" ? 5 : b.visitor.indexOf("택배") !== -1 ? 4 : b.visitor.length >= "3" ? 3 : b.company.indexOf('(완료)') !== -1 ? 2 : b.visitor === "미정" ? 1 : -1;
                if (aHasWord > bHasWord)return 1; // a를 뒤로
                if (aHasWord < bHasWord)return -1; // b를 뒤로
                return 0; // a, b 모두 단어가 있거나, 둘 다 없는 경우 원래 순서 유지
              })
            }
            for(let i = 0; i < visitman.length; i++){
              const SortingArr = visitman[i].delivery.sort((a, b) => a.sort - b.sort || a.company.localeCompare(b.company));
              visitman[i].delivery = SortingArr;
            }
            let groupingString = '';
            let rowNumb = 0;
            let initialMaterial = '';
            for(let i = 0; i < order_server_Data.data[3].length; i++){
              const inputID = 'input-'+order_server_Data.data[3][i].id+',';
              if(groupingString === order_server_Data.data[3][i].grouping){
                rowNumb++;
                receiveList[receiveList.length-1].material = initialMaterial+' 외 '+rowNumb+' 종';
                receiveList[receiveList.length-1].weight = receiveList[receiveList.length-1].weight+Number(order_server_Data.data[3][i].weight);
                receiveList[receiveList.length-1].idList = receiveList[receiveList.length-1].idList+inputID;
                receiveList[receiveList.length-1].itemList = receiveList[receiveList.length-1].itemList+(rowNumb+1)+' :'+order_server_Data.data[3][i].material+':'+order_server_Data.data[3][i].weight+'\n';
              }else{
                groupingString = order_server_Data.data[3][i].grouping;
                rowNumb = 0;
                initialMaterial = order_server_Data.data[3][i].material;
                receiveList.push({
                  id:order_server_Data.data[3][i].id,
                  idList:inputID,
                  company:order_server_Data.data[3][i].company,
                  material:order_server_Data.data[3][i].material,
                  weight:Number(order_server_Data.data[3][i].weight),
                  note:order_server_Data.data[3][i].note,
                  grouping:Number(order_server_Data.data[3][i].grouping),
                  itemList:'[구매 : '+order_server_Data.data[3][i].company+']\n'+(rowNumb+1)+' :'+order_server_Data.data[3][i].material+':'+order_server_Data.data[3][i].weight+'\n'
                })
              }
            }
            setVisitCompanyResult([...visitOtherDay])
            setGetdataresult([...orderdata]);
            setGetVisitresult([...visitman]);
            setAsapList([...asapArr]);
            setAfterbuyList([...afterbuy]);
            setFinishedOrder([...finishedOrder]);
            setReceiveList([...receiveList])
            setNotDepositList([...notdepositdata]);
            setMemo({
              api:'/orderboard/memo',
              sendbutton:'메모변경 전송',
              contents:order_server_Data.data[5]
            })
            setStopCheck([...stopList]);
            //console.log(stopList);

            //check : order - stock 
            const order_list = [];
            for(let i = 0; i < orderdata.length; i++){
              for(let j = 0; j < orderdata[i].order_info.length; j++){
                const companyname = orderdata[i].order_company;
                const material =  orderdata[i].order_info[j].material;
                const materialcode = orderdata[i].order_info[j].material_code;
                const material_weight = orderdata[i].order_info[j].material_weight;
                const delivery_date = orderdata[i].order_info[j].delivery_date;
                const inputdate = orderdata[i].order_info[j].inputdate;
                order_list.push([materialcode,material,material_weight,companyname,inputdate,delivery_date,]);
              }
            }
            order_list.sort((a, b) => {
              if (a[0] === b[0]) {
                const data_A = new Date(a[4]);
                const data_B = new Date(b[4]);
                return data_A - data_B; // 두 번째 기준 오름차순
              }
              return a[0] - b[0]; // 첫 번째 기준 오름차순
            });
            const { stockCode, stockWeight } = order_server_Data.data[6].reduce((acc, curr) => {
              acc.stockCode.push(curr.품목코드);
              acc.stockWeight.push(curr.현재고);
              return acc;
            }, { stockCode: [], stockWeight: [] });
            const overseaMaterial = [];
            for(let i = 0; i < order_server_Data.data[7].length; i++){
              const code = order_server_Data.data[7][i].품목코드;
              overseaMaterial.push(code);
            }
            const stockList = [];
            let materialStockList = [];
            let material_code = 'firstcode';
            let material_name = 'firstname';
            let material_stock = 0;
            let material_remain = 0;
            for(let i = 0; i < order_list.length; i++){
              const overseaCheck = overseaMaterial.indexOf(order_list[i][0]);
              if(overseaCheck === -1){continue;}

              if(order_list[i][0] === ''){
                stockList.push({material:[order_list[i][1],'코드x',''],orderList:[[order_list[i][3],order_list[i][2],order_list[i][4],order_list[i][5],'코드없음']],remain:'코드없음'});
                continue;
              }
              if(order_list[i][0] !== material_code ){
                if(material_code !== 'firstcode'){
                  stockList.push({material:[material_name,material_stock,material_code],orderList:materialStockList,remain:material_remain});
                }
                material_code = order_list[i][0];
                material_name = order_list[i][1];
                materialStockList = [];
                material_remain = Number(stockWeight[stockCode.indexOf(material_code)]);
                material_stock = Number(stockWeight[stockCode.indexOf(material_code)]);
              }
              if(order_list[i][0] === material_code ){
                const output = Number(order_list[i][2]);
                material_remain = Math.round( (material_remain - output)*100 )/100;
                materialStockList.push([order_list[i][3],order_list[i][2],order_list[i][4],order_list[i][5],material_remain])
              }
              if(i === order_list.length-1){
                stockList.push({material:[material_name,material_stock,material_code],orderList:materialStockList,remain:material_remain});
              }
            }
            setStockList(stockList);
            //console.log(order_server_Data.data[1],order_server_Data.data[2]);
          }
          settings();
          const nowdate = new Date();
          const hours = nowdate.getHours() > 12 ? nowdate.getHours()-12 : nowdate.getHours();
          const minutes = nowdate.getMinutes();
          const seconds = nowdate.getSeconds();
          prevCount = `${hours}시 ${minutes}분 ${seconds}초`;
          setNowtime(prevCount);
        }); // 이전의 값을 기억하고 넘겨준다.
      }, 5000);
      return () => {
        clearInterval(intervalId); // Unmount시 clearInterval() 이 호출되어 메모리 누수를 방지
      };
    },[orderDay]);
  }
Counter();
  //check 배송,납품처 단어 확인
  function containsKeyword(textNote,keywordslist) {
    for (let i = 0; i < keywordslist.length; i++){
      let checkContainsWord = '';
      if(textNote === null){
        checkContainsWord = -1;
      }else{
        checkContainsWord = textNote.indexOf(keywordslist[i]) ?? -1;
      }
      if ( checkContainsWord !== -1) {
        const lastwordposition = textNote.indexOf(' ',checkContainsWord);
        const otherPlace = lastwordposition === -1 ? textNote.substring(checkContainsWord,textNote.length) : textNote.substring(checkContainsWord,lastwordposition);
        return '➡'+otherPlace; // 하나라도 발견되면 true 반환
      }
    }
    return ''; // 아무것도 없으면 false
  }
  function checkResult(result){
    const nullish = result ?? 'nullish';
    if(nullish === 'nullish')return '';
    if(result === 'O')return '(완료)';
    return '';
  }
  function containsKeytoDirect(textNote,textVisitor) {
    const keywordslist = ['택배','수향택배','착불택배','직송','화물'];
    for (let i = 0; i < keywordslist.length; i++){
      let checkContainsWord = '';
      if(textNote === null){
        return '';
      }else{
        checkContainsWord = textNote.indexOf(keywordslist[i]) ?? -1;
      }
      if( checkContainsWord !== -1) {
        return `${keywordslist[i]}-`; // 하나라도 발견되면 true 반환
      }
    }
    return textVisitor === '직송' ? '직송-' : ''; // 아무것도 없으면 false
  }

  //order_Company_buttons function
  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorE2, setAnchorE2] = useState(false);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);
  const handleClick = (index,event) => {
    setAnchorEl({ [index]: event.currentTarget});
  };
  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick2 = (index,event) => {
    setAnchorE2({ [index]: event.currentTarget});
  };
  const handleClose2 = () => {
    setAnchorE2(false);
  };
  const changeSomeDelivery = (tabletype,_idList,afterValue) => {
    axios.get(`${databaseUrl}/orderboard/changesomdelivery?id=${_idList}&delivery=${afterValue}&tabletype=${tabletype}`,
      {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
        if(response.data === 'NotAdmin'){alert('Not permitted');}
        handleClose2();
    })
  }
  const changeDelivery = (_id,beforeValue,afterValue) => {
    let beforeSet = beforeValue ?? '미정';
    let afterSet = beforeValue === afterValue ? '미정' : afterValue;
    axios.get(`${databaseUrl}/orderboard/changedelivery?id=${_id}&delivery=${afterSet}&beforevalue=${beforeSet}`,
      {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
        if(response.data === 'NotAdmin'){alert('Not permitted');}
        handleClose();
    })
  }
  const changePositon = (_id,before_postion,after_positon) => {
    const position = before_postion === after_positon ? 'none' : after_positon;
    axios.get(`${databaseUrl}/orderboard/changeposition?id=${_id}&position=${position}`,
      {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
        if(response.data === 'NotAdmin'){alert('Not permitted');}
        handleClose();
    })
  }
  const checkfinished = (_id,deliverydate,companyname,material,weight) => {
    if(window.confirm(`${deliverydate} / ${companyname} / ${material} / ${weight} kg 완료처리 진행?`)){
      axios.get(`${databaseUrl}/orderboard/checkfinished?id=${_id}`,
        {headers: {Authorization:`Bearer ${access}`},}
        ).then((response)=>{
          if(response.data === 'NotAdmin'){alert('Not permitted');}
          handleClose();
      })
    }
  }

  const checkValue = (_id,columnName,beforeValue) => {
    alert('미완');
    handleClose();
  }
  const changeDay = (e) =>{
    e.preventDefault();
    console.log(e.target.value);
  }

  function insertCompany(day,visitman) {
    const prompValue = prompt(`${day},${visitman} 추가 일정 입력`,'') ?? 'nothing';
    if(prompValue !== 'nothing'){
      const visitday = day;
      const visithuman = visitman; 
      axios.get(`${databaseUrl}/orderboard/insertvisit?day=${visitday}&visitman=${visithuman}&visitplace=${prompValue}`,
        {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
      }).catch((error)=>{
        alert(error.message);
      })
    }
  }

  const deleteVisit = (_id,man,company) => {
   if(window.confirm(`${man} 일정, ${company} 삭제?`) ) {
    axios.get(`${databaseUrl}/orderboard/deletevisit?id=${_id}`,
      {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
        if(response.data === 'NotAdmin'){
          alert('Not permitted');
        }
    })
   }
  }
  const checkDiposit = (_id,price) => {
    return window.open(`${databaseNoport}/ChangeDeposit?id=${_id}`,'targetWindow',
      `toolbar=no,
       location=no,
       top=300,
       left=500,
       status=no,
       menubar=no,
       scrollbars=yes,
       resizable=yes,
       width=1000px,
       height=300px`);
  }
//moddals
  const [openmodal, setOpenmodal] = useState(false);
  const handleModalOpen = () => {
    setOpenmodal(true)
  };
  const handleModalClose = () => setOpenmodal(false);
  const tolinks = `/Orderboards_select_man?visitday=${orderDay}`;


  const changeDate = (dataID) => {
    return window.open(`${databaseNoport}/changedate?id=${dataID}`,'targetWindow',
                                   `toolbar=no,
                                    location=no,
                                    top=300,
                                    left=500,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    width=950px,
                                    height=280px`);
  }
  const notApproch = (dataID) => {
    return window.open(`${databaseNoport}/notapproch?id=${dataID}`,'targetWindow',
                                   `toolbar=no,
                                    location=no,
                                    top=300,
                                    left=500,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    width=750px,
                                    height=280px`);
  }
  const changeApproch = (_id,_date,_companyname,_material,_weight) => {
    if(window.confirm(`${_companyname} / ${_material} / ${_weight} kg 입고후 원료 변경 진행?`)){
      const sendData = axiosInstance.get(`${databaseUrl}/orderboard/notapproch?id=${_id}&chdate=${_date}&stop=1`);
    }
    handleClose();
  }
  const changeDeliveryDate = (tabletype,dataIDList) => {
    handleClose2();
    const idlist = dataIDList.slice(0, -1);
    const opentype = tabletype === 'order_boards' ? 'changemanydate' : 'changereceivedate';
    return window.open(`${databaseNoport}/${opentype}?id=${idlist}`,'targetWindow',
                                   `toolbar=no,
                                    location=no,
                                    top=300,
                                    left=500,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    width=1000px,
                                    height=400px`);
  }
  const changeFinished = async (tabletype,dataIDList,deliverydate,companyname,weight) => {
    const idlist = dataIDList.slice(0, -1);
    if(window.confirm(`${deliverydate} / ${companyname} / ${weight} kg 완료처리 진행?`)){
      const getResult = await axiosInstance.get(`/orderboard/checkmanyfinished?id=${idlist}&tabletype=${tabletype}`);
    }
  }
  const unFinished = async (dataIDList,deliverydate,_company,weight) => {
    const tabletype = dataIDList.substring(0,5);
    const isNumber = (value) => {return typeof value === 'number' && isFinite(value)};
    const idlist = isNumber(dataIDList) === true ? dataIDList : dataIDList.slice(0, -1);
    if(window.confirm(`${deliverydate} / ${_company} / ${weight} kg 완료 취소?`)){
      const getResult = await axiosInstance.get(`/orderboard/unfinished?id=${idlist}&tabletype=${tabletype}`);
    }
  }
return (
  <div className="orderboards">
    <div className="time_order">
      <div className="selectman">
        <Link to='/Orderboards_select_man'  state={{ data: orderDay}} >
         <Button variant="outlined" color="secondary">select Man</Button>
        </Link>
        <Link to='/Orderboards_select_car'  state={{ data: orderDay}} >
         <Button variant="outlined" color="secondary">select Car</Button>
        </Link>
        <Link to='/DepositcompanyList'  state={{ data: orderDay}} >
         <Button variant="outlined" color="secondary">선입금업체</Button>
        </Link>
        <Link to='/DataInput'  state={{ data: orderDay}} >
         <Button variant="outlined" color="secondary">DataInput</Button>
        </Link>
      </div>
      <div className="orderboard_orderday">
        <div><Button variant="outlined" onClick={beforeOrderDay}>◀</Button></div>
        <input type="date" value={orderDay} className="outputdate"  onChange={clickOrderday} />
        <div><Button variant="outlined" onClick={afterOrderDay}>▶</Button></div>
      </div>
      <div className="order_time">{nowtime}</div>
    </div>
      <div className="salesman">
      {getVisitresult.map( (data,i) =>
      <table key={i} className="nonbordertable">
        <thead>
            {data.visitman !== '직송' && data.visitman !== '미정' && data.visitman.indexOf("택배") === -1 && data.visitman !== '화물' && data.visitman !== '직접수령' ? 
            <tr key={i}>
              <th><Button variant="outlined" color="inherit" size="small" > {data.visitman} </Button></th>
              <th>{data.car}</th>
              <th><Button  variant="contained" color="success" size="small"  style={{width:'10px',padding:'0px'}} onClick={()=>insertCompany(orderDay,data.visitman)}>추가</Button></th>
            </tr>: <tr colSpan={2}><th>{data.visitman}</th></tr> }
        </thead>
        <tbody>
          <tr>
            <td colSpan={3}>
              <ul style={{padding:0}}>
                {data.delivery.map((delivery,j,arr) =>  
                  delivery.weight !== 0 ?
                  <li key={j} className="visitmanList"
                  draggable
                  onDragStart={(e) => dragStart(e, j)}
                  onDragEnter={(e) => dragEnter(e, j)}
                  onDragEnd={()=>drop(arr)}
                  onDragOver={(e) => e.preventDefault()}
                  ><div>{delivery.company}</div><div>{delivery.weight}</div></li>
                  :
                  <li key={j+100} className="visitmanList"
                  draggable
                  onDragStart={(e) => dragStart(e, j)}
                  onDragEnter={(e) => dragEnter(e, j)}
                  onDragEnd={()=>drop(arr)}
                  onDragOver={(e) => e.preventDefault()}
                  ><div>{delivery.company}</div><Button variant="outlined" size="small" style={{width:'10px',padding:'0px'}} onClick={()=>deleteVisit(delivery.id,data.visitman,delivery.company)}>X</Button></li>
                )}
              </ul>
            </td>
          </tr>

                {/* 
          <tr>
            <td colSpan={3}>
              <ul style={{padding:0}}>
                {data.delivery.map((delivery,j,arr) =>  
                  delivery.weight !== 0 ?
                  <li key={j} className="visitmanList"
                  draggable
                  onDragStart={(e) => dragStart(e, j)}
                  onDragEnter={(e) => dragEnter(e, j)}
                  onDragEnd={()=>drop(arr)}
                  onDragOver={(e) => e.preventDefault()}
                  ><div onClick={()=>checkWork(data.delivery[j])}
                  >{delivery.company}</div><div>{delivery.weight}</div></li>
                  :
                  <li key={j+100} className="visitmanList"
                  draggable
                  onDragStart={(e) => dragStart(e, j)}
                  onDragEnter={(e) => dragEnter(e, j)}
                  onDragEnd={()=>drop(arr)}
                  onDragOver={(e) => e.preventDefault()}
                  ><div>{delivery.company}</div><Button variant="outlined" size="small" style={{width:'10px',padding:'0px'}} onClick={()=>deleteVisit(delivery.id,data.visitman,delivery.company)}>X</Button></li>
                )}
              </ul>
            </td>
          </tr>
          

          
  const checkWork = (visitInfo) => {
    if(window.confirm(`${man} 일정, ${company} 현출변경?`) ) {
//      axios.get(`${databaseUrl}/orderboard/deletevisit?id=${_id}`,
//        {headers: {Authorization:`Bearer ${access}`},}
//        ).then((response)=>{
//          if(response.data === 'NotAdmin'){
//            alert('Not permitted');
//          }
//      })
    }
    confirm('check up');
    console.log(visitInfo);
  }
          


                
                */}
        </tbody>
      </table>
      )}
      </div>
      <div className="ordercompany">
      {getVisitCompanyResult.map((days,i)=> 
        <table  style={{borderLeft:'1px solid red'}}  key={i} className={days.date === orderDay ? 'nonbordertable checkVisitCompanyList' : 'nonbordertable'}>
          <thead>
            <tr>
              <th colSpan={3}>{days.date} [{checkWeek[new Date(days.date).getDay()]}]</th>
            </tr>
          </thead>
          <tbody>
          {days.delivery.map((companylist,j) =>
          companylist.weight !== 0 && companylist.company.indexOf('(완료)') === -1 && companylist.company.indexOf('입고-') === -1 ? 
          <tr key={j}>
            <td className={companylist.visitor === '미정' ? 'blue' :companylist.visitor.indexOf("택배") !== -1 ? 'red' : 'black'}>{companylist.visitor}</td>
            <td className="visitcompanyname">
            <Button
              variant="outlined" 
              color="inherit"
              id={companylist.company+companylist.weight}
              aria-controls={open2 ? companylist.company+companylist.weight+'|'+companylist.company : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? 'true' : undefined}
              onClick={(e)=>handleClick2(companylist.weight+i*1000000000+j*10000, e)}
              size="small"
              sx={{width:'175px',minHeight:'25px',paddingTop:'0px',paddingBottom:'0px',fontSize:'0.9rem',overflow :'hidden',justifyContent: "flex-start",userSelect: 'text'}}
            >
              {companylist.company}
            </Button>
            <Menu
              id={companylist.company+companylist.weight}
              aria-labelledby={companylist.company+companylist.weight+'|'+companylist.company}
              anchorEl={anchorE2 && anchorE2[companylist.weight+i*1000000000+j*10000]}
              open={anchorE2 && Boolean(anchorE2[companylist.weight+i*1000000000+j*10000])}
              onClose={handleClose2}
              anchorOrigin={{vertical: 'top',horizontal: 'left',}}
              transformOrigin={{vertical: 'top',horizontal: 'left',}}
              sx={{ whiteSpace: 'pre-line' }}
            ><div style={{backgroundColor:'yellow'}}>
              {companylist.company} <br></br>
              {companylist.materialList.map((value)=>
              <>{value.material}:{value.weight}{value.note === undefined ? "" : value.note.trim().length === 0 ? "":  value.note.trim().length === 0 ? "": "/비고: "+value.note}<br></br> </>
            )}</div>
              <MenuItem onClick={()=>{changeFinished('order_boards',companylist.id_List,days.date,companylist.company,companylist.weight)}}>{days.date} [{companylist.company}] 일괄완료 처리 </MenuItem>
              {getVisitresult.map( (visitor,i)=>
                <MenuItem onClick={()=>changeSomeDelivery('order_boards',companylist.id_List,visitor.visitman)}>{days.date} [{companylist.company}] [{visitor.visitman}] 변경 </MenuItem>
              )}
              <MenuItem onClick={()=>{
                handleClose2();
                changeDeliveryDate('order_boards',companylist.id_List)}}>{days.date} [{companylist.company}] 배송일정 변경</MenuItem>
            </Menu>
            </td>
            <td className="visitcompanyweight">{companylist.weight}</td>
          </tr> 
          :
          companylist.weight !== 0 && companylist.company.indexOf('(완료)') === -1?
          <tr key={j}>
            <td className={companylist.visitor === '미정' ? 'blue' :companylist.visitor.indexOf("택배") !== -1 ? 'red' : 'black'}>{companylist.visitor}</td>
            <td className="visitcompanyname">
            <Button
              variant="contained" 
              color="primary"
              id={companylist.company+companylist.weight}
              aria-controls={open2 ? companylist.company+companylist.weight+'|'+companylist.company : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? 'true' : undefined}
              onClick={(e)=>handleClick2(companylist.weight+i*1000000000+j*10000, e)}
              size="small"
              sx={{width:'175px',minHeight:'25px',paddingTop:'0px',paddingBottom:'0px',fontSize:'0.9rem',overflow :'hidden',justifyContent: "flex-start",userSelect: 'text'}}
            >
              {companylist.company}
            </Button>
            <Menu
              id={companylist.company+companylist.weight}
              aria-labelledby={companylist.company+companylist.weight+'|'+companylist.company}
              anchorEl={anchorE2 && anchorE2[companylist.weight+i*1000000000+j*10000]}
              open={anchorE2 && Boolean(anchorE2[companylist.weight+i*1000000000+j*10000])}
              onClose={handleClose2}
              anchorOrigin={{vertical: 'top',horizontal: 'left',}}
              transformOrigin={{vertical: 'top',horizontal: 'left',}}
              sx={{ whiteSpace: 'pre-line' }}
            ><div style={{backgroundColor:'yellow'}}>
              {companylist.company} <br></br>
              {companylist.materialList.map((value)=>
              <>{value.material}:{value.weight}{value.note === undefined ? "" : "/비고: "+value.note}<br></br> </>
            )}</div>
              <MenuItem onClick={()=>{changeFinished('receive',companylist.id_List,days.date,companylist.company,companylist.weight)}}>{days.date} [{companylist.company}] 일괄완료 처리 </MenuItem>
              {getVisitresult.map( (visitor,i)=>
                <MenuItem onClick={()=>changeSomeDelivery('receive',companylist.id_List,visitor.visitman)}>{days.date} [{companylist.company}] [{visitor.visitman}] 변경 </MenuItem>
              )}
              <MenuItem onClick={()=>{changeDeliveryDate('receive',companylist.id_List)}}>{days.date} [{companylist.company}] 입고일정 변경</MenuItem>

            </Menu>
            </td>
            <td className="visitcompanyweight">{companylist.weight}</td>
          </tr> 
          : 
          <tr key={j}>
            <td className={companylist.visitor === '미정' ? 'blue' :companylist.visitor.indexOf("택배") !== -1 ? 'red' : 'black'}>{companylist.visitor}</td>
            <td className="visitcompanyname">
            <Button
              variant="contained" 
              id={companylist.company+companylist.weight}
              aria-controls={open2 ? companylist.company+companylist.weight+'|'+companylist.company : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? 'true' : undefined}
              onClick={(e)=>handleClick2(companylist.weight+i*1000000000+j*10000, e)}
              size="small"
              sx={{width:'175px',minHeight:'25px',paddingTop:'0px',paddingBottom:'0px',fontSize:'0.8rem',overflow :'hidden',justifyContent: "flex-start",userSelect: 'text',backgroundColor:'RGB(0, 50, 0)'}}
            >
              {companylist.company}
            </Button>
            <Menu
              id={companylist.company+companylist.weight}
              aria-labelledby={companylist.company+companylist.weight+'|'+companylist.company}
              anchorEl={anchorE2 && anchorE2[companylist.weight+i*1000000000+j*10000]}
              open={anchorE2 && Boolean(anchorE2[companylist.weight+i*1000000000+j*10000])}
              onClose={handleClose2}
              anchorOrigin={{vertical: 'top',horizontal: 'left',}}
              transformOrigin={{vertical: 'top',horizontal: 'left',}}
              sx={{ whiteSpace: 'pre-line' }}
            ><div style={{backgroundColor:'yellow'}}>
              {companylist.company} <br></br>
              {companylist.materialList.map((value)=>
              <>{value.material}:{value.weight}{value.note === undefined ? "" : value.note.trim().length === 0 ? "": "/비고: "+value.note}<br></br> </>
            )}</div>
              <MenuItem onClick={()=>{
                handleClose2();
                unFinished(companylist.id_List,days.date,companylist.company,companylist.weight)}}>{days.date} [{companylist.company}] 일괄완료 해지 </MenuItem>            
            </Menu>
            </td>
            <td className="visitcompanyweight">{companylist.weight}</td>
          </tr>
          )}
            </tbody>
        </table>
      )}
        <div>
          <table>
            <tr>
              <th colSpan={4}>입고 원료 LIST</th>
            </tr>
            <tr>
              <th>No</th>
              <th>입고 원료</th>
              <th>kg</th>
              <th>비고</th>
            </tr>
            {receiveList.map((data,i) =>
            <tr>
              <td>{i+1}</td>
              <td><Button
                variant="outlined" 
                color="inherit"
                id={data.company+data.weight}
                aria-controls={open2 ? data.company+data.weight+'|'+data.company : undefined}
                aria-haspopup="true"
                aria-expanded={open2 ? 'true' : undefined}
                onClick={(e)=>handleClick2(data.grouping, e)}
                size="small"
                sx={{width:'175px',minHeight:'25px',paddingTop:'0px',paddingBottom:'0px',fontSize:'0.9rem',overflow :'hidden',justifyContent: "flex-start"}}
              >
                {data.material}
              </Button>
              <Menu
              id={data.company+data.weight}
              anchorEl={anchorE2 && anchorE2[data.grouping]}
              open={anchorE2 && Boolean(anchorE2[data.grouping])}
              onClose={handleClose2}
              anchorOrigin={{vertical: 'top',horizontal: 'left',}}
              transformOrigin={{vertical: 'top',horizontal: 'left',}}
              sx={{ whiteSpace: 'pre-line' }}
            ><div style={{backgroundColor:'yellow'}}>{data.itemList}</div>
              <MenuItem onClick={()=>{
                handleClose2(); // 먼저 메뉴 닫기
                changeDeliveryDate('receive',data.idList)}}> [{data.company}] 배송일정 변경</MenuItem>
            </Menu>
              </td>
              <td>{data.weight}</td>
              <td>{data.note}</td>
            </tr>
            )}
          </table>
        </div>

        {/* // check not approch materials */}
        <div>
          <table style={{borderCollapse:'collapse',border:'1px solid black'}}>
          {stopCheck.map((data,i)=>
            stopCheck.length > 1 && i === 0? 
            <>
            <tr><th colSpan={6}>미업고 원료 리스트 [{stopCheck.length}]</th></tr>
            <tr>
              <th>발주 업체명</th>
              <th>원료</th>
              <th>수량</th>
              <th>발주일</th>
              <th>납품일</th>
              <th align="left">비고</th>
            </tr>
            <tr>
            <td align="left">
              <div>{data.order_company}</div>
            </td>
            <td align="left">
              <Button onClick={()=>notApproch(data.id)} variant="outlined" color="primary"  style={{width:'100%'}}>{data.material}</Button>
            </td>
            <td align="right"><div>{data.material_weight}</div></td>
            <td><div>{data.inputdate.substring(0,10)}</div></td>
            <td><div>{data.delivery_date}</div></td>
            <td align="left"><div>{data.note}</div></td>
            </tr>
            </>
            :
            <>
            <tr>
            <td align="left">
              <div>{data.order_company}</div>
            </td>
            <td align="left">
              <Button onClick={()=>notApproch(data.id)} variant="outlined" color="primary"  style={{width:'100%'}}>{data.material}</Button>
            </td>
            <td align="right"><div>{data.material_weight}</div></td>
            <td><div>{data.inputdate.substring(0,10)}</div></td>
            <td><div>{data.delivery_date}</div></td>
            <td align="left"><div>{data.note}</div></td>
            </tr>
            </>
          )}
          </table>
        </div>

        <div style={{display:'flex',flexDirection:'column'}}>
          {asapList.length !== 0 ? 
            <table className="orderboard_table" style={{marginBottom:"20px"}}>
              <thead>
                <tr><td colSpan={5}>ASAP List</td></tr>
                <tr>
                  <th>회사명</th>
                  <th>원료명</th>
                  <th>Kg</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
              {asapList.map((data,i) => 
                <tr>
                  <td>{data.order_company}</td>   
                  <td>{data.material}</td>   
                  <td>{data.material_weight}</td>   
                  <td style={{width:'200px'}}>{data.note}</td>
                </tr>
              )} 
              </tbody>
            </table> 
            :
            ''
          }
          {afterbuyList.length !== 0 ? 
            <table className="orderboard_table" style={{marginBottom:"20px"}}>
            <thead>
              <tr><td colSpan={5}>수입후 출고</td></tr>
              <tr>
                <th>회사명</th>
                <th>원료명</th>
                <th>Kg</th>
                <th>비고</th>
                </tr>
              </thead>
              <tbody>
              {afterbuyList.map((data,i) => 
                <tr>
                  <td>{data.order_company}</td>   
                  <td>{data.material}</td>   
                  <td>{data.material_weight}</td>   
                  <td>{data.note}</td>
                </tr>
              )} 
              </tbody>
            </table> 
            :
            ''
        }
        </div>
        <div style={{width:'400px',border:'1px solid red'}}>
          <h3>MEMO</h3>
          <div dangerouslySetInnerHTML={{ __html:memo.contents}} style={{textAlign:'left',paddingLeft:'10px',paddingRight:'10px'}} />
          <div><Button 
            onClick={()=>showeditor()}
          >{memoEditor}</Button></div>
          <div className={memoEditorState === 0 ? 'hide': ''}>
            <TextEditor 
              data={memo} 
              value={memoUpdate}
              onChange={setMemoUpdate}
            />
          </div>
        </div>
      </div>
      <div className="new_order">
      <Link to='/Order' state={{ data: orderDay}} >
        <Button variant="outlined" color="secondary">New Order</Button>
      </Link>
      <Link to='/Receive' state={{ data: orderDay}} >
        <Button variant="outlined" color="secondary">Receiving</Button>
      </Link>
      </div>
      <div className="orderlist">
      {getdataresult.map( (data1,i) => 
        <table className="orderboard_table orderlist_table" key={i}>
        <tbody>
          {data1.order_info.map( (data,index) =>
            <tr key={index}>
              <td className={data.delivery_date === orderDay? 'company_name red' : data.delivery_date < orderDay ? 'company_name purple' : 'company_name black'}>{index === 0 ? data.order_company : ''}</td>
              <td className={data.delivery_date === orderDay && data.delivery === '미정' ? 'red' : data.delivery_date < orderDay ? 'purple' : 'black'} style={{lineHeight:'15px'}}>
                {data.delivery.indexOf('택배') === -1 ? data.delivery.substring(0,2): data.delivery === '택배' ? '택배' : data.delivery === '수향택배' ? '수택' : data.delivery === '착불택배' ? '착택' : data.delivery }</td>
              <td>
              <Button
                variant={data.delivery_date === orderDay ? 'contained' : 'outlined' }
                color={data.delivery_date === orderDay ? 'warning' : 'inherit' }
                id={data.id}
                aria-controls={open ? data.id+'|'+data.material : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(e)=>handleClick(data.id, e)}
                size="small"
                sx={{color:Number(data.stop) !== 0 || data.note.indexOf('입고후') !== -1 ? 'brown':'black',
                     width:'180px',
                     height:'25px',
                     letterSpacing:'-1px',
                     fontWeight:'600',
                     fontSize:'0.9rem',
                     overflow :'hidden',
                     whiteSpace:'nowrap',
                     textOverflow:'ellipsis',
                     justifyContent: "flex-start",
                     userSelect: 'text'
                }}
              >
                {data.material}
              </Button>
              <Menu
                id={data.id+data.delivery}
                aria-labelledby={data.id+'|'+data.material}
                anchorEl={anchorEl && anchorEl[data.id+0]}
                open={anchorEl && Boolean(anchorEl[data.id+0])}
                onClose={handleClose}
                anchorOrigin={{vertical: 'top',horizontal: 'left',}}
                transformOrigin={{vertical: 'top',horizontal: 'left',}}
              >
                <MenuItem onClick={()=>checkfinished(data.id,data.delivery_date,data.order_company,data.material,data.material_weight)}>[{data.order_company}] {data.material} [완료]처리</MenuItem>
                {getVisitresult.map( (visitor,i)=>
                  <MenuItem onClick={()=>changeDelivery(data.id,data.delivery,visitor.visitman)}>[{data.order_company}] {data.material} [{visitor.visitman}] {data.delivery === visitor.visitman ? '취소' : '변경' } </MenuItem>
                )}

                <MenuItem onClick={()=>changePositon(data.id,data.position,'수향')}>[{data.order_company}] {data.material} 수향 {data.position === '수향' ? '취소' : '변경' }</MenuItem>
                <MenuItem onClick={()=>changePositon(data.id,data.position,'일산')}>[{data.order_company}] {data.material} 일산 {data.position === '일산' ? '취소' : '변경' }</MenuItem>
                <MenuItem onClick={()=>changeApproch(data.id,data.delivery_date,data.order_company,data.material,data.material_weight)}>[{data.order_company}] {data.material} 입고후 원료 이동</MenuItem>
              </Menu>
              </td>
              <td className="position red">{data.position}</td>
              <td className={data.note.indexOf('재고없음') !== -1 ? "material_weight red" : "material_weight"} >{data.material_weight}</td>
              <td className={data.delivery_date === orderDay? 'due_date red' : data.delivery_date < orderDay ? 'due_date purple' : 'due_date black'}>
                { data.note.indexOf('재고없음') !== -1 || data.note.indexOf('수입후') !== -1 || data.note.indexOf('입고후') !== -1 ?
                  <div className="blue">입고후</div>
                  :
                  data.note.indexOf('입금후출고') !== -1 ?
                  <div className="red">입금후</div>
                  :
                  data.delivery_date < orderDay ? 
                  <Button  
                  variant="outlined" size="small" sx={{minHeight:'25px',fontSize:'0.8rem',userSelect: 'text'}}  
                  onClick={()=>changeDate(data.id)}>
                    <div>{data.delivery_date.substring(5,10)}
                      <div>납품일이 지남</div>
                    </div>
                  </Button> 
                  : 
                  <Button  
                  variant="outlined" size="small" sx={{minHeight:'25px',userSelect: 'text'}} 
                  onClick={()=>changeDate(data.id)}>
                    {data.delivery_date.substring(5,10)}
                  </Button> 
                }
                {data.deposit === 'O' ? 
                  data.deposit_day === '' ? 
                  <div>
                    <Button variant="contained" color="error" size="small" 
                    onClick={()=>checkDiposit(data.id,data.deposit_price)}>
                      선입금
                    </Button>
                  </div> 
                  : 
                  <div>{data.deposit_day+'입금확인'}</div>
                  :
                  '' 
                }
              </td>
              <td className="note">{data.note}</td>
            </tr>
          )}
        </tbody>
      </table>
      )}

      <div id="depositlist">
        {notdepositList.map( (data1,i) => 
        <table className="orderboard_table orderlist_table" key={i}>
        <tbody>
          {data1.order_info.map( (data,index) =>
            <tr key={index}>
              <td className={data.delivery_date === orderDay? 'company_name red' : data.delivery_date < orderDay ? 'company_name purple' : 'company_name black'}>{index === 0 ? data.order_company : ''}</td>
              <td className={data.delivery_date === orderDay && data.delivery === '미정' ? 'red' : data.delivery_date < orderDay ? 'purple' : 'black'} style={{lineHeight:'15px'}}>
                {data.delivery.indexOf('택배') === -1 ? data.delivery.substring(0,2): data.delivery === '택배' ? '택배' : data.delivery === '수향택배' ? '수택' : data.delivery === '착불택배' ? '착택' : data.delivery }</td>
              <td>
              <Button
                variant={data.delivery_date === orderDay ? 'contained' : 'outlined' }
                color='inherit'
                id={data.id}
                aria-controls={open ? data.id+'|'+data.material : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(e)=>handleClick(data.id, e)}
                size="small"
                sx={{width:'180px',
                     height:'25px',
                     letterSpacing:'-1px',
                     fontWeight:'600',
                     fontSize:'0.9rem',
                     overflow :'hidden',
                     whiteSpace:'nowrap',
                     textOverflow:'ellipsis',
                     justifyContent: "flex-start",
                     userSelect: 'text'
                }}
              >
                {data.material}
              </Button>
              <Menu
                id={data.id+data.delivery}
                aria-labelledby={data.id+'|'+data.material}
                anchorEl={anchorEl && anchorEl[data.id+0]}
                open={anchorEl && Boolean(anchorEl[data.id+0])}
                onClose={handleClose}
                anchorOrigin={{vertical: 'top',horizontal: 'left',}}
                transformOrigin={{vertical: 'top',horizontal: 'left',}}
              >
                <MenuItem onClick={()=>checkfinished(data.id,data.delivery_date,data.order_company,data.material,data.material_weight)}>[{data.order_company}] {data.material} [완료]처리</MenuItem>
                {getVisitresult.map( (visitor,i)=>
                  <MenuItem onClick={()=>changeDelivery(data.id,data.delivery,visitor.visitman)}>[{data.order_company}] {data.material} [{visitor.visitman}] {data.delivery === visitor.visitman ? '취소' : '변경' } </MenuItem>
                )}
                <MenuItem onClick={()=>changePositon(data.id,data.position,'수향')}>[{data.order_company}] {data.material} 수향 {data.position === '수향' ? '취소' : '변경' }</MenuItem>
                <MenuItem onClick={()=>changePositon(data.id,data.position,'일산')}>[{data.order_company}] {data.material} 일산 {data.position === '일산' ? '취소' : '변경' }</MenuItem>

              </Menu>
              </td>
              <td className="position red">{data.position}</td>
              <td className={data.note.indexOf('재고없음') !== -1 ? "material_weight red" : "material_weight"} >{data.material_weight}</td>
              <td className={data.delivery_date === orderDay? 'due_date red' : data.delivery_date < orderDay ? 'due_date purple' : 'due_date black'}>
                { data.note.indexOf('재고없음') !== -1 || data.note.indexOf('수입후') !== -1 || data.note.indexOf('입고후') !== -1 ?
                  <div className="blue">입고후</div>
                  :
                  data.note.indexOf('입금후출고') !== -1 ?
                  <div className="red">입금후</div>
                  :
                  data.delivery_date < orderDay ? 
                  <Button  
                  variant="outlined" size="small" sx={{minHeight:'25px',fontSize:'0.8rem'}}  
                  onClick={()=>changeDate(data.id)}>
                    <div>{data.delivery_date.substring(5,10)}
                      <div>납품일이 지남</div>
                    </div>
                  </Button> 
                  : 
                  <Button  
                  variant="outlined" size="small" sx={{minHeight:'25px'}} 
                  onClick={()=>changeDate(data.id)}>
                    {data.delivery_date.substring(5,10)}
                  </Button> 
                }
                {data.deposit === 'O' ? 
                  data.deposit_day === '' ? 
                  <div>
                    <Button variant="contained" color="error" size="small" 
                    onClick={()=>checkDiposit(data.id,data.deposit_price)}>
                      선입금
                    </Button>
                  </div> 
                  : 
                  <div>{data.deposit_day+'입금확인'}</div>
                  :
                  '' 
                }
              </td>
              <td className="note">{data.note}</td>
            </tr>
          )}
        </tbody>
      </table>
      )
        }
      </div>
     </div>
     <div className="orderlist" style={{backgroundColor:'darkgrey'}}>
      {finishedOrder.length > 1 ? <div><h1>{orderDay} 완료 품목</h1></div> : <></>}
     {finishedOrder.map( (data1,i) => 
        <table className="orderboard_table orderlist_table" key={i}>
        <tbody>
          {data1.order_info.map( (data,index) =>
            <tr key={index}>
              <td className='company_name black'>{index === 0 ? data.order_company : ''}</td>
              <td className={data.delivery_date === orderDay && data.delivery === '미정' ? 'red' : data.delivery_date < orderDay ? 'purple' : 'black'} style={{lineHeight:'15px'}}>
                {data.delivery.indexOf('택배') === -1 ? data.delivery.substring(0,2): data.delivery === '택배' ? '택배' : data.delivery === '수향택배' ? '수택' : data.delivery === '착불택배' ? '착택' : data.delivery }</td>
              <td>
              <Button
                variant={data.delivery_date === orderDay ? 'contained' : 'outlined' }
                color='inherit'
                id={data.id}
                aria-controls={open ? data.id+'|'+data.material : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(e)=>handleClick(data.id, e)}
                size="small"
                sx={{width:'180px',
                     height:'25px',
                     letterSpacing:'-1px',
                     fontWeight:'600',
                     fontSize:'0.9rem',
                     overflow :'hidden',
                     whiteSpace:'nowrap',
                     textOverflow:'ellipsis',
                     justifyContent: "flex-start",
                     userSelect: 'text'
                }}
              >
                {data.material}
              </Button>
              <Menu
                id={data.id+data.delivery}
                aria-labelledby={data.id+'|'+data.material}
                anchorEl={anchorEl && anchorEl[data.id+0]}
                open={anchorEl && Boolean(anchorEl[data.id+0])}
                onClose={handleClose}
                anchorOrigin={{vertical: 'top',horizontal: 'left',}}
                transformOrigin={{vertical: 'top',horizontal: 'left',}}
              >
                <MenuItem onClick={()=>unFinished(data.id,data.delivery_date,data.order_company,data.material,data.material_weight)}>[{data.order_company}] {data.material} [완료취소]처리</MenuItem>
              </Menu>
              </td>
              <td className="position red">{data.position}</td>
              <td className={data.note.indexOf('재고없음') !== -1 ? "material_weight red" : "material_weight"} >{data.material_weight}</td>
              <td className='due_date black'>
                {data.delivery_date.substring(5,10)}
                {data.deposit === 'O' ? 
                  data.deposit_day === '' ? 
                  <div>
                    <Button variant="contained" color="error" size="small" 
                    onClick={()=>checkDiposit(data.id,data.deposit_price)}>
                      선입금
                    </Button>
                  </div> 
                  : 
                  <div>{data.deposit_day+'입금확인'}</div>
                  :
                  '' 
                }
              </td>
              <td className="note">{data.note}</td>
            </tr>
          )}
        </tbody>
      </table>
      )}
     </div>
     <div>
     <div>
      <Button variant="contained" color="primary" style={{width:'100%'}} 
        onClick={() => {if(showTable) {setShowTable(false)} else {setShowTable(true)}}}>발주 대비 재고 상황[수입원료] {showTable === false ? 'SHOW' : 'HIDE'} </Button></div> 
     <table border={1} 
     style={{
      borderCollapse:'collapse',
      border:'1px solid black',
      display:showTable === false ? 'none' : 'block'
      }}>
      <thead>
        <tr style={{top:'0',position:'sticky',backgroundColor:'white'}}>
          <th>No</th>
          <th>원료명</th>
          <th>현재고</th>
          <th>발주업체</th>
          <th>발주수량</th>
          <th>발주일</th>
          <th>납품일(예정)</th>
          <th>출고후 재고량</th>
          <th>발주 출고 후 재고</th>
        </tr>
      </thead>
      <tbody>
        {stockList.map((object, i) =>
          object.orderList.map((data, j) => (
            <tr key={`${i}-${j}`} style={{borderTop:j===0 ?'4px solid black' : '1px soild black'}}>
              {j === 0 && (
                <>
                <td rowSpan={object.orderList.length}>
                  {i + 1}
                </td>
                <td rowSpan={object.orderList.length} align="left" style={{paddingLeft:'5px'}}>
                  {object.material[0]}
                </td>
                <td rowSpan={object.orderList.length} align="right" style={{paddingRight:'5px'}}>
                  {object.material[1]}
                </td>
              </>
              )}
              <td align="left" style={{paddingLeft:'5px'}}>{data[0]}</td>
              <td align="right" style={{paddingRight:'5px'}}>{data[1]}</td>
              <td style={{padding:'5px'}}>{data[2].substring(0, 10)}</td>
              <td style={{padding:'5px'}}>{data[3]}</td>
              <td align="right" style={{paddingRight:'5px',color:data[4]<=0?'red':'black'}}><b>{data[4]}</b></td>
              {j === 0 && (
              <td rowSpan={object.orderList.length} style={{color:object.remain<0?'red':'black'}}>
                {object.remain}
              </td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </table>
     </div>
  </div>
);
};
export default Orderboards;